export default {"src":"/_next/static/image/public/assets/icons/formal.e449f5db2b013419203a57948663756b.svg","height":20,"width":20};